import { render, staticRenderFns } from "./VehicleInspection.vue?vue&type=template&id=f640a4ea&scoped=true"
import script from "./VehicleInspection.vue?vue&type=script&lang=js"
export * from "./VehicleInspection.vue?vue&type=script&lang=js"
import style0 from "./VehicleInspection.vue?vue&type=style&index=0&id=f640a4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f640a4ea",
  null
  
)

export default component.exports